import { useContext } from 'react';
import { has } from 'lodash';
import type { SupportedFlagTypes } from '@atlassian/help-center-common-util/feature-manager/types';
import { FeatureFlagsContext } from './provider';

export interface Props {
    children: JSX.Element;
    showIf?: 'enabled' | 'disabled';
    name: string;
    defaultValue: SupportedFlagTypes;
}

const FeatureFlag = ({ children, name, defaultValue, showIf = 'enabled' }: Props): JSX.Element | null => {
    const flags = useContext(FeatureFlagsContext);
    let value = defaultValue;

    if (has(flags, name)) {
        value = !!flags[name];
    }

    const shouldShow = showIf === 'enabled' ? value : !value;
    return shouldShow ? children : null;
};

export default FeatureFlag;
